/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * DSV Public API
 * DSV Public API
 * OpenAPI spec version: 1.2.3
 */
import type {
  Event,
  EventId,
  EventRegistrationForm,
  EventRegistrationRequest,
  EventRegistrationResponse,
  Feedback,
  GetEventRegistrationFormParams,
  GetSermonScheduleParams,
  GetSpecialDayNotificationCalendarHeaders,
  GetSpecialDayNotificationCalendarParams,
  GetSpecialOfferingsParams,
  MasterDataBillingCountry,
  SermonSchedule,
  SpecialDayNotificationId,
  SpecialOffering
} from './model';

import { dsvApiAxiosInstance } from '../../../dsv-api-axios-instance';



  /**
 * @summary Get event
 */
export const getEvent = (
    eventId: EventId,
 ) => {
      return dsvApiAxiosInstance<Event>(
      {url: `/public/api/events/${eventId}`, method: 'GET'
    },
      );
    }
  
/**
 * @summary Get registration form
 */
export const getEventRegistrationForm = (
    eventId: number,
    params?: GetEventRegistrationFormParams,
 ) => {
      return dsvApiAxiosInstance<EventRegistrationForm>(
      {url: `/public/api/events/${eventId}/registration/form`, method: 'GET',
        params
    },
      );
    }
  
/**
 * @summary Save event registration
 */
export const saveEventRegistration = (
    eventId: number,
    eventRegistrationRequest: EventRegistrationRequest,
 ) => {
      return dsvApiAxiosInstance<EventRegistrationResponse>(
      {url: `/public/api/events/${eventId}/registrations`, method: 'POST',
      headers: {'Content-Type': 'application/vnd.dsv.event-registration.v1+json;charset=utf-8', },
      data: eventRegistrationRequest
    },
      );
    }
  
/**
 * @summary Send feedback
 */
export const sendFeedback = (
    feedback: Feedback,
 ) => {
      return dsvApiAxiosInstance<void>(
      {url: `/public/api/feedback`, method: 'POST',
      headers: {'Content-Type': 'application/vnd.dsv.feedback.v1+json;charset=utf-8', },
      data: feedback
    },
      );
    }
  
/**
 * @summary Get billing countries
 */
export const getBillingCountries = (
    
 ) => {
      return dsvApiAxiosInstance<MasterDataBillingCountry[]>(
      {url: `/public/api/master-data/billing-countries`, method: 'GET'
    },
      );
    }
  
/**
 * @summary Returns a sermon schedule for a given year and month
 */
export const getSermonSchedule = (
    params: GetSermonScheduleParams,
 ) => {
      return dsvApiAxiosInstance<SermonSchedule>(
      {url: `/public/api/sermon-schedule`, method: 'GET',
        params
    },
      );
    }
  
/**
 * @summary Returns a calendar with all special day notifications for the next 2 years
 */
export const getSpecialDayNotificationCalendar = (
    specialDayNotificationId: SpecialDayNotificationId,
    params?: GetSpecialDayNotificationCalendarParams,
    headers?: GetSpecialDayNotificationCalendarHeaders,
 ) => {
      return dsvApiAxiosInstance<Blob>(
      {url: `/public/api/special-day-notifications/${specialDayNotificationId}.ics`, method: 'GET',
      headers,
        params,
        responseType: 'blob'
    },
      );
    }
  
/**
 * @summary List all special offerings
 */
export const getSpecialOfferings = (
    params: GetSpecialOfferingsParams,
 ) => {
      return dsvApiAxiosInstance<SpecialOffering[]>(
      {url: `/public/api/special-offerings`, method: 'GET',
        params
    },
      );
    }
  

type AwaitedInput<T> = PromiseLike<T> | T;

    type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

export type GetEventResult = NonNullable<Awaited<ReturnType<typeof getEvent>>>
export type GetEventRegistrationFormResult = NonNullable<Awaited<ReturnType<typeof getEventRegistrationForm>>>
export type SaveEventRegistrationResult = NonNullable<Awaited<ReturnType<typeof saveEventRegistration>>>
export type SendFeedbackResult = NonNullable<Awaited<ReturnType<typeof sendFeedback>>>
export type GetBillingCountriesResult = NonNullable<Awaited<ReturnType<typeof getBillingCountries>>>
export type GetSermonScheduleResult = NonNullable<Awaited<ReturnType<typeof getSermonSchedule>>>
export type GetSpecialDayNotificationCalendarResult = NonNullable<Awaited<ReturnType<typeof getSpecialDayNotificationCalendar>>>
export type GetSpecialOfferingsResult = NonNullable<Awaited<ReturnType<typeof getSpecialOfferings>>>
